export default __webpack_public_path__ + "static/media/girl_ramp_young.217ef733.jpg";